

<template>
  <BaseModal :isShow="isShow" @close="closeModal" size="costum" >
    <div class="m-2">
      <IconClose class="cursor-pointer"  @click="closeModal" />
    </div>
    <div class="p-6">
      <video ref="video" preload="none" class="min-w-full laptop:min-w-[800px]" controls>
        <source :src="src" type="video/mp4" />
      </video>
    </div>
  </BaseModal>
</template>

<script setup>
const props = defineProps({
  isShow: Boolean,
  src: String
})
const emit = defineEmits(['close'])
const video = ref()
const closeModal = () => {
  video.value.pause();
  video.value.currentTime = 0;
  emit('close')
}
watch(() => props.isShow, (newVal) => {
  if (newVal === true) {
    video.value.play();
  }
})

</script>